import React, { FC } from 'react';

import TopBar from '~/components/TopBar';

import { DelayedDeliveryProps } from './models';

const DelayedDelivery: FC<DelayedDeliveryProps> = ({
  messageDisplayed,
  delayedDeliveryMessage,
}) => (
  <TopBar
    soloMode
    showInfoBar={messageDisplayed && delayedDeliveryMessage.length > 0}
    className="delayed-delivery"
    messages={[{ text: delayedDeliveryMessage }]}
  />
);

export default DelayedDelivery;
